import styled, { css } from 'styled-components';
import LXStyledButton from './core';

const LXSmallButton = styled(LXStyledButton)`
  height: var(--bt-sm-height);
  padding: var(--bt-sm-padding);
  font-size: var(--bt-sm-font-size);
  line-height: var(--bt-sm-line-height);
  border-radius: var(--bt-sm-border-radius);
  ${(props) =>
    props.kind === 'secondary' &&
    css`
      color: var(--bt-sm-secondary);
      background-color: var(--bt-sm-secondary-bg);
      &:hover {
        background-color: var(--bt-sm-secondary-hover);
      }
    `}
`;

export default LXSmallButton;
